import loadImg from '@/assets/images/load.gif'
import { Button, Flex } from '@/components'
import { WideForm } from '@/components/core/WideForm/WideForm.component'
import { Layout } from '@/components/layout'
import { Routes } from '@/configs'
import { useRouting } from '@/hooks'
import { CenaContainer, CenaHeaderContainer, CenaTitleContainer, VerticalDivider } from './Cena.styles'
import { CenaImprensa } from './components/Imprensa/Imprensa.component'
import { CenaRede } from './components/Rede/Rede.component'
import { CenaProvider, useCenaContext } from './Cena.context'
import { Favorability } from './components/Favorability/Favorability.component'
import { Alert, Api } from '@/modules'
import { mapContextToRequest, mapResponseToContext } from './Cena.mapper'
import { GetCenaResponse } from '@shared/models'
import { useEffect } from 'react'

export function Cena() {
  return (
    <CenaProvider>
      <Component />
    </CenaProvider>
  )
}

export function Component() {
  const { navigate } = useRouting()
  const { getAllData, rede, imprensa, favorabilidade, updateRede, updateImprensa, updateFavorabilidade } =
    useCenaContext()
  const { sendAlert } = Alert.Hook()

  const { isRunning: isCreatingCena, run: createCena } = Api.Command<void>(Api.Methods.POST, `cena`)

  const [isLoadingCena, reloadCena, cena, findCenaError] = Api.Query<GetCenaResponse>(`cena`)

  if (findCenaError) {
    sendAlert({
      type: 'error',
      title: 'Não foi possível buscar os dados icena',
      message: 'Ocorreu um erro ao buscar os dados icena.',
    })
  }

  useEffect(() => {
    if (cena) {
      try {
        const currentData = { rede, imprensa, favorabilidade }

        const { social, press, favorability } = mapResponseToContext(cena, currentData)

        updateRede(social)
        updateImprensa(press)
        updateFavorabilidade(favorability)
      } catch (error) {
        console.log('error: ', error)
        sendAlert({
          type: 'error',
          title: 'Erro de Mapeamento',
          message: 'Os dados foram carregados, mas houve um erro ao preencher o formulário.',
        })
      }
    }
  }, [cena])

  function onSubmit() {
    const data = getAllData()

    const input = mapContextToRequest(data)

    createCena({
      input,
      onSuccess: () => {
        sendAlert({
          type: 'success',
          title: 'Sucesso',
          message: 'Configurações de cálculo ICENA salvas com sucesso!',
        })
        navigate(Routes.Home)
      },
    })

    reloadCena()
  }

  return (
    <Layout.Root noMenu>
      <Layout.Padder>
        <CenaContainer>
          <CenaHeaderContainer>
            <CenaTitleContainer>
              <h1>Configuração Cálculo ICENA</h1>
              <span>Configure os pesos e parâmetros para o cálculo do Índice CENA</span>
            </CenaTitleContainer>
            <Button.Root onClick={() => navigate(Routes.Home)} $variant="outlined">
              Voltar
            </Button.Root>
          </CenaHeaderContainer>

          <WideForm onSubmit={onSubmit} shouldExpand={true}>
            {isLoadingCena ?
              <Flex $type="row" $align="center" $justify="center" style={{ padding: '50px', width: '100%' }}>
                <img src={loadImg} alt="Carregando..." style={{ width: '2.4rem', height: '2.4rem' }} />
              </Flex>
            : <>
                <Flex $type="row" $align="flex-start" $gap={32} $fit>
                  <CenaRede />
                  <VerticalDivider />
                  <CenaImprensa />
                </Flex>
                <Flex $type="column" $align="center">
                  <Favorability />
                </Flex>
                <Flex $type="row" $justify="flex-end" $align="stretch" $gap={20} $fit>
                  <Button.Root type="submit" $variant="primary" $size={156} $loading={isCreatingCena}>
                    <Button.Text value="Salvar" />
                  </Button.Root>
                </Flex>
              </>
            }
          </WideForm>
        </CenaContainer>
      </Layout.Padder>
    </Layout.Root>
  )
}
